import { FC } from "react";
import { IconPropsType } from ".";

export const Preview: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_9452_394)">
        <path
          d="M3 4V4C2.17157 4 1.5 4.67157 1.5 5.5V13.5C1.5 14.6046 2.39543 15.5 3.5 15.5H11.5C12.6046 15.5 13.5 14.6046 13.5 13.5V6.5"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M4 9.5H8"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M4 12.5H6"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M9 6.5C7.1579 6.5 5 4 5 4C5 4 7.1579 1.5 9 1.5C10.8421 1.5 13 4 13 4C13 4 10.8421 6.5 9 6.5Z"
          stroke={props.color}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 4C9.75 4.41421 9.41421 4.75 9 4.75C8.58579 4.75 8.25 4.41421 8.25 4C8.25 3.58579 8.58579 3.25 9 3.25C9.41421 3.25 9.75 3.58579 9.75 4Z"
          fill={props.color}
        />
      </g>
      <defs>
        <clipPath id="clip0_9452_394">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
